import styled from 'styled-components';

/** Срок хранения помеченного на удаление совещания, дни (зеркалит бэкенд RETENTION_DAYS). */
export const MEETING_RETENTION_DAYS = 30;

/**
 * Сколько дней осталось до безвозвратной зачистки помеченного на удаление
 * совещания. 0 — срок истёк (вот-вот будет вычищено фоновым планировщиком).
 */
export function deletionDaysLeft(deletedAt: string | null | undefined): number {
  if (!deletedAt) return 0;
  const elapsedDays = Math.floor((Date.now() - new Date(deletedAt).getTime()) / 86_400_000);
  return Math.max(0, MEETING_RETENTION_DAYS - elapsedDays);
}

/** Бейдж «помечено на удаление» (кримсон, как у статусов «на проверку»). */
export const DeletionBadge = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: ${({ theme }) => theme.radius.pill};
  color: crimson;
  border: 1px solid crimson;
  white-space: nowrap;
`;
